const rateLimitErrorHandler = () => {
    console.log("RateLimit - Application Gateway error 403 *********Inside rateLimitErrorHandler*********** ");
    alert("Some Apps or Processors are overloading the server. Please try after sometime.");
}

export {
    rateLimitErrorHandler
}